// LRPO-5819 — "Hidden companies cannot be expanded in Notify text".
//
// The Notify sentence names the first few values and then says "N more"
// (LRPO-5791). That was plain text, so clicking it did nothing. It is now a
// button and this reveals the rest.
//
// ⚠ THE HIDDEN VALUES ARE ALREADY IN THE PAGE, rendered and escaped by the
// server. This controller only flips their visibility — it never builds markup
// from a value, because those values are company names and demographic answers
// typed by users. If you ever need to write one into the DOM here, use
// textContent, never innerHTML.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "hidden"]

  toggle() {
    if (!this.hasHiddenTarget || !this.hasButtonTarget) return

    const nowHidden = !this.hiddenTarget.hidden
    this.hiddenTarget.hidden = nowHidden

    // The label swaps between "N more" and "show fewer". Both come from data
    // attributes the server rendered, so the count stays correct without this
    // controller ever having to know it.
    const { moreLabel, lessLabel } = this.buttonTarget.dataset
    this.buttonTarget.textContent = nowHidden ? moreLabel : lessLabel

    // Screen readers need to know this is a disclosure, not a link to nowhere.
    this.buttonTarget.setAttribute("aria-expanded", String(!nowHidden))
  }
}
